import { quantityInit } from "./quantity"
import { productSliderInit } from "./slider"
import { productZoom } from "./zoom"
import { quantityCompositeInit } from "./quantity-composite"
import { switchPriceInit } from "./switch-price"
import { mobileProductInit } from "./mobile"

export const productInit = () => {
  quantityInit()
  productSliderInit()
  productZoom()
  quantityCompositeInit()
  switchPriceInit()
  mobileProductInit()
}
